import React from 'react';
import { createRoot } from 'react-dom/client';

import '@progress/kendo-ui';
import '@progress/kendo-ui/js/cultures/kendo.culture.sk-SK.js';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { MetaProvider } from './coraWebComponents/utils/withMeta';

import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import './coraWebComponents/_index.scss';
import './index.scss';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';

import thunk from 'redux-thunk';
import rootReducer from './reducers';
import logger from './coraWebComponents/utils/logger';
import { composeWithDevTools } from 'redux-devtools-extension';

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, logger))
);

const root = createRoot(document.getElementById('root'));

root.render(
  <MetaProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </MetaProvider>
);

if (window.config.enableServiceWorker) {
  registerServiceWorker();
}
else {
  unregister();
}